import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { MessageSquare } from 'lucide-react';

const CommentModal = ({
  open,
  onClose,
  onSubmit,
  title = "Add Remark",
  description = "Please provide your remark",
  placeholder = "Enter your remark here...",
  submitText = "Submit",
  isLoading = false,
}) => {
  const [remark, setRemark] = useState('');

  const handleSubmit = async () => {
    if (!remark.trim()) {
      return;
    }
    try {
      await onSubmit(remark.trim());
      // Clear remark on successful submission
      setRemark('');
    } catch (error) {
      // Keep remark if submission fails
      console.error('Remark submission failed:', error);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[500px] w-[95vw]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <MessageSquare className="w-5 h-5" />
            {title}
          </DialogTitle>
         
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="remark">Remark <span className="text-red-500">*</span></Label>
            <Textarea
              id="remark"
              placeholder={placeholder}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              className="min-h-[100px] focus-gold"
              required
            />
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <Button 
            variant="outline" 
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSubmit}
            disabled={!remark.trim() || isLoading}
            className="bg-yellow-600 hover:bg-yellow-700"
          >
            {isLoading ? 'Submitting...' : submitText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CommentModal;